var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile__invoices" }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("profile.account.recentInvoices")))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "invoices__wrapper" },
      _vm._l(_vm.items, function(invoice, i) {
        return _c("div", { key: i, staticClass: "invoice" }, [
          _c("span", { staticClass: "invoice__number" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("profile.account.invoice")) +
                " #" +
                _vm._s(invoice.number) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "invoice__content-wrapper" }, [
            invoice.status === "paid"
              ? _c("img", {
                  attrs: {
                    src:
                      "/media/inpulse-template-ac-new-a/profile/home/paid.png",
                    alt: "paid"
                  }
                })
              : _c("img", {
                  attrs: {
                    src:
                      "/media/inpulse-template-ac-new-a/profile/home/not-paid.png",
                    alt: "not paid"
                  }
                }),
            _vm._v(" "),
            _c("div", { staticClass: "invoice__content" }, [
              _c("span", { staticClass: "invoice__price" }, [
                _vm._v(_vm._s(invoice.amount))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "invoice__date" }, [
                _vm._v(_vm._s(invoice.created_at))
              ])
            ])
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }